// extracted by mini-css-extract-plugin
export var numpadContainer = "_ms-1";
export var phoneButton = "_ms-0";